import React from 'react'
import ReactDOM from 'react-dom'
import App from 'application'

ReactDOM.render(<App />, document.getElementById('root'))
